// @ts-nocheck

import { type ObjectValuesUnionType } from '../utils/typing';

export const UserAccountService = 'pages/user/account/';

export const UserAccountMessages = Object.freeze({
  LOADED: 'loaded',
  CLOSE: 'close',
  LOGOUT: 'logout',
  REDIRECT: 'redirect',
});
export type UserAccountMessage = ObjectValuesUnionType<typeof UserAccountMessages>;

export const UserAccountPages = Object.freeze({
  COMMUNICATION_PREFERENCES: 'mailing-preferences',
});
export type UserAccountPage = ObjectValuesUnionType<typeof UserAccountPages>;
